import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemPanel } from '../item-panel/item-panel';
import { Item, SelectionEvent as PanelSelectionEvent } from '../item-panel/item-panel.model';

// The specific interface for this component's data
export interface HardwareInterfaceFilter {
  id: number;
  label: string; // The interface name
  selected?: boolean;
}

// This component's own event payload interface
export interface HardwareInterfaceFilterSelectionEvent {
  source: HardwareInterfaceFilter | null;
  selected: HardwareInterfaceFilter[];
}

@Component({
  selector: 'app-hardware-interface-filter-panel',
  standalone: true,
  imports: [ItemPanel],
  templateUrl: './hardware-interface-filter-panel.html',
  styleUrl: './hardware-interface-filter-panel.scss',
})
export class HardwareInterfaceFilterPanel implements OnInit {
  @Input() title: string = '';
  @Input() interfaceFilterList: HardwareInterfaceFilter[] = [];
  /** This component's own output, using its own specific event type. */
  @Output() selectionChanged = new EventEmitter<HardwareInterfaceFilterSelectionEvent>();

  // This array is what gets passed to the generic ItemPanel component.
  panelItems: Item[] = [];

  ngOnInit(): void {
    // Maps the detailed HardwareInterfaceFilter data to the generic Item structure needed by the child panel.
    this.panelItems = this.interfaceFilterList.map((interfaceFilter) => ({
      id: interfaceFilter.id,
      label: interfaceFilter.label,
      selected: interfaceFilter.selected ?? false,
    }));
  }

  /** Handles the generic event from the child panel and maps it to a specific event. */
  onPanelSelectionChange(panelEvent: PanelSelectionEvent): void {
    // 1. Find the full records for all selected items
    const selectedIds = new Set(panelEvent.selectedItems.map((item) => item.id));
    const selectedFilters = this.interfaceFilterList.filter((interfaceFilter) =>
      selectedIds.has(interfaceFilter.id)
    );

    // 2. Find the full record for the source item that was toggled
    const sourceFilter = panelEvent.source
      ? this.interfaceFilterList.find((p) => p.id === panelEvent.source?.id) ?? null
      : null;

    // 3. Construct and emit this component's own, specific event payload
    this.selectionChanged.emit({
      source: sourceFilter,
      selected: selectedFilters,
    });
  }
}
